<style lang="scss" scoped>

.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

</style>

<template>
    <Modal ref="modal">
        <template v-slot:title>
            <span v-if="isMode('new')">Entnahme dokumentieren</span>
            <span v-if="isMode('new_completely')">Entnahme dokumentieren</span>
            <span v-if="isMode('complete')">Entnahme abschließen</span>     
            <span v-if="isMode('view')">Dokumentierte Entnahme</span>    
            <span v-if="isMode('alter')">Dokumentierte Entnahme ändern</span>
        </template>
        
       <!-- Select WaterPoint --> 
       
       <!-- {{ profile }} | {{ showTransferIrrigationLevel }} | {{ mode }} | {{ waterPointId }} [ {{ isDocumentationAllowed }} ] --> 
       
       <div class="row mt-1 mb-3">
            <div class="col-12">
                <label class="form-label">
                    Entnahmestelle
                </label>
                <WaterPointSelect v-model:waterPointId="waterPointId" :disabled="isProfileWaterPoint" referrer="/withdrawal?action=newwithdrawal"></WaterPointSelect>
            </div>
        </div>
       
       <Alert type="danger" :show="alert.waterPoint" :timeout="6000">
                <template v-slot:title>Entnahmestelle fehlt</template>
                Bitte wählen Sie eine Entnahmestelle
       </Alert>
       
       <WaterPointWellAlert :waterPointId="waterPointId"></WaterPointWellAlert>
     
       <!-- Select Profile, if not determined --> 
       
       <div v-if="!profile.area" class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Schlagfläche in Hektar</label>
                <FloatInput v-model:value="area" :imaskOptions="{mask:'0[00]{,}000 h\\a',overwrite: true, eager: true, lazy: false}"
                :digits="3" placeholder="Fläche des Schlags in ha" :disabled="isMode(['view','complete'])" >
                </FloatInput>
            </div>           
        </div>
        
        <Alert type="danger" :show="alert.areaEmpty" :timeout="3000">
            <template v-slot:title>Schlagfläche fehlt</template>
            Bitte geben Sie die Schlagfläche in Hektar an. Bitte beachten Sie, dass die Schlagfläche später nicht mehr verändert werden kann
        </Alert> 
        
        <!-- Start Date --> 
                
        <div class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Start der Entnahme</label>
            </div>
            <div class="col">
                <div class="input-icon">
                  <DatePickerInput ref="startDate" v-model:date="startDate" :minDate="getMinDateTime().format('YYYY-MM-DD')" :maxDate="getMaxDateTime().format('YYYY-MM-DD')" :disabled="isMode(['view','complete','alter'])"></DatePickerInput>
                  <span class="input-icon-addon">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <rect x="4" y="5" width="16" height="16" rx="2"></rect>
                        <line x1="16" y1="3" x2="16" y2="7"></line>
                        <line x1="8" y1="3" x2="8" y2="7"></line>
                        <line x1="4" y1="11" x2="20" y2="11"></line>
                        <line x1="11" y1="15" x2="12" y2="15"></line>
                        <line x1="12" y1="15" x2="12" y2="18"></line>
                     </svg>
                  </span>
                </div>
            </div>
            <div class="col">
                <TimeInput v-model:value="startTime" mask="0[0]:0[0]" placeholder="Uhrzeit (HH:MM)" :disabled="isMode(['view','complete','alter'])"></TimeInput>     
            </div>
       </div>
       
       <!-- Extraction Rate (depricated) --> 
       
       <div v-if="false" class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Förderleistung der Entnahme in m³/h</label>
                <RangeSliderInput v-model:value="extractionRate" :disabled="false" mask="0[00]" ></RangeSliderInput>
            </div>     
       </div>
       
       <Alert type="danger" :show="alert.extractionRate" :timeout="6000">
            <template v-slot:title>Förderleistung der Entnahme</template>
            Förderleistung der Entnahme fehlt
       </Alert> 
       
       <!-- Counters --> 

       <div class="row mt-3 mb-2">
            <div class="col-12 mb-0">
                <label v-if="isMode(['view','new_completely','complete','alter'])" class="form-label">
                    Zählerstand zu Beginn / zum Ende der Entnahme
                </label>
                 <label v-else class="form-label">
                    Zählerstand zu Beginn der Entnahme
                </label>
            </div>
            <div class="col">
                <FloatInput v-model:value="countStart" :imaskOptions="{mask:'0[00000]{,}000 m³',overwrite: true, lazy:false}"
                :digits="3" placeholder="Zu Beginn in m³" v-on:focusOut="countStartChanged" :disabled="isMode(['view','complete'])" :focus="!countStart && isMode('new_completely')">
                </FloatInput>
            </div>
            
            <div v-if="isMode(['new_completely','complete','view','alter'])" class="col">
                <FloatInput v-model:value="countEnd" :imaskOptions="{mask:'0[00000]{,}000 m³',overwrite: true, lazy:false}"
                :digits="3" placeholder="Zum Ende in m³" v-on:focusOut="countEndChanged" :disabled="isMode(['view'])" :focus="countStart && isMode(['new_completely','complete'])">
                </FloatInput>
            </div>
        </div>
        
        <Alert type="danger" :show="alert.countStartEnd" :timeout="6000">
            <template v-slot:title>Zählerstände fehlen</template>
            Bitte trägen Sie die Zählerstände ein
        </Alert>
        
        <Alert type="danger" :show="alert.countStart" :timeout="6000">
            <template v-slot:title>Zählerstände zu gering</template>
            Der Zählerstand darf nicht geringer sein, als der Zählerstand zur letzten Entnahme
        </Alert>
        
        <!-- Transfer Irrigation Level --> 
        
        <transition name="fade">
        <div v-if="showTransferIrrigationLevel" class="row mt-3 mb-2">
            <div class="col-12">
                <label v-if="!disabledTransferIrrigationLevel" class="form-label">Berechnete Gabenhöhe in App übernehmen?</label>
                <label v-else class="form-label">Berechnete Gabenhöhe in App übernommen</label>
                <ButtonCheckBox v-model:checked="isTransferIrrigationLevel" :disabled="disabledTransferIrrigationLevel">
                    {{ labelLevel ? labelLevel : 'Unvollständige Eingaben' }}
                    {{ area ? '' : 'Schlagfläche nicht angegeben' }}
                </ButtonCheckBox> 
            </div>
        </div>
        </transition>
        
        
        <TransferIrrigationLevel v-if="!isMode('new') && false" v-model:transferLevel="transferIrrigationLevel" :countStart="countStart" :countEnd="countEnd" :mode="mode"></TransferIrrigationLevel>
        
        <!-- Comment --> 
        
        <div v-if="(comment && isMode('view')) || isMode('alter')" class="row mt-3 mb-2">
            <div class="col-12 mb-0">
                <label class="form-label">Begründung für die Änderung<span class="form-label-description">{{ comment ? comment.length: 0 }}/150</span></label>
                <textarea v-model="comment" :disabled="['view'].includes(mode)" class="form-control" maxlength="150" name="example-textarea-input" rows="4" placeholder="Begründung für die Änderung"></textarea>
            </div>
        </div>
       
        <Alert type="danger" :show="alert.comment" :timeout="6000">
            <template v-slot:title>Begründung erforderlich</template>
            Eine nachträgliche Änderungen der Eingaben ist nur mit Begründung von mindestens {{ minCommentLength }} Zeichen möglich
        </Alert>
         
        <!-- Complete Dokumenation --> 
        
        <div v-if="isMode(['new','new_completely'])" class="row mt-3 mb-2">
            <div class="col-12">
                <label class="form-label">Dokumentation nach der Entnahme abschließen</label>
                <ButtonCheckBox v-model:checked="isCreateComplete">
                    Dokumentation sofort abschließen?
                    <template v-slot:isChecked>Dokumentation sofort abschließen</template>
                </ButtonCheckBox> 
            </div>
        </div>
       
        <Alert type="danger" :show="alert.area">
            <template v-slot:title>Bitte bachten Sie</template>
                Die Schlagfläche kann später nicht mehr verändert werden. Wenn Sie sicher sind, dass 
                die Eingabe der Größe des Schlages von <b>{{ area ? area.toFixed(3).replace('.',',') : '' }} ha</b> korrekt ist,
                klicken Sie bitte erneut auf „Speichern“.
        </Alert>
        
        <!-- Modal Footer --> 
       
        <template v-slot:footer>
             <template v-if="false && !isWellStillWaterLevelDocumented">
                <button type="button" class="btn me-auto" @click="closeModal">
                    Abbrechen
                </button>
                
                <router-link to="/level?action=newlevel" class="btn btn-info ms-auto" @click="closeModal">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <circle cx="14" cy="6" r="2"></circle>
                        <line x1="4" y1="6" x2="12" y2="6"></line>
                        <line x1="16" y1="6" x2="20" y2="6"></line>
                        <circle cx="8" cy="12" r="2"></circle>
                        <line x1="4" y1="12" x2="6" y2="12"></line>
                        <line x1="10" y1="12" x2="20" y2="12"></line>
                        <circle cx="17" cy="18" r="2"></circle>
                        <line x1="4" y1="18" x2="15" y2="18"></line>
                        <line x1="19" y1="18" x2="20" y2="18"></line>
                  </svg>
                    Zum Ruhewasserstand
                </router-link>
            </template>
            <template v-if="isMode(['new','new_completely','complete'])">
                <button type="button" class="btn me-auto" @click="closeModal">
                    Abbrechen
                </button>
                
                <a href="#" class="btn btn-info ms-auto" @click="submit">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
                      <polyline points="7 11 12 16 17 11" />
                      <line x1="12" y1="4" x2="12" y2="16" /> 
                  </svg>
                    Speichern
                </a>
            </template>
            <template v-else-if="isMode(['view'])">
                <button type="button" class="btn me-auto" @click="closeModal">
                    Ok
                </button>
                
                <a href="#" class="btn btn-info ms-auto" @click="changeMode('alter')">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M9 7h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3" />
                      <path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3" />
                      <line x1="16" y1="5" x2="19" y2="8" />
                  </svg>
                   Maßnahme ändern
                </a>
            </template>
            <template v-else-if="isMode(['alter'])">
                <button type="button" class="btn me-auto" @click="closeModal">
                    Abbrechen
                </button>
                
                <a href="#" class="btn btn-info ms-auto" @click="submit">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
                      <polyline points="7 11 12 16 17 11" />
                      <line x1="12" y1="4" x2="12" y2="16" />   
                  </svg>
                    Änderungen speichern
                </a>
            </template>            
        </template>
    </Modal>
</template>


<script>
import * as dayjs from 'dayjs';
import MinMax from 'dayjs/plugin/minMax';
dayjs.extend(MinMax)

import Modal from '@/components/Modal.vue';
import Alert from '@/components/Alert.vue';
import DatePickerInput from '@/components/input/DatePickerInput.vue';
import RangeSliderInput from '@/components/input/RangeSliderInput.vue';
import TimeInput from '@/components/input/TimeInput.vue';
import FloatInput from '@/components/input/FloatInput.vue';
import TransferIrrigationLevel from '@/components/irrigation/TransferIrrigationLevel.vue';
import WaterPointSelect from '@/components/waterpoint/WaterPointSelect.vue';
import WaterPointWellAlert from '@/components/waterpoint/WaterPointWellAlert.vue';
import ButtonCheckBox from '@/components/input/ButtonCheckBox.vue';

export default {
    name: 'Precipitation Alter Modal',
    components: {
        Modal,
        Alert,
        DatePickerInput,
        RangeSliderInput,
        WaterPointSelect,
        WaterPointWellAlert,
        FloatInput,
        TimeInput,
        TransferIrrigationLevel,
        ButtonCheckBox
    },
    inject: [
        'state',
        'config'
    ],
    props: {
        mode: {
            type: String,
            default: 'new'
        },
        profile: {
            type: Object,
            default: undefined
        },
        irrigation: {
            type: Object,
            default: null
        },
        irrigationList: {
            type: Array,
            default: null
        }
    },
    data: function () {
        return {
            waterPointId: null,
            extractionRate: null,
            area: null,
            startDate: null,
            startTime: null,
            countStart: null,
            countEnd: null,
            stillWaterLevel: null,    
            normalWaterLevel: null,
            comment: '',
            isTransferIrrigationLevel: null,
            images: [],
            files: [],
            isCreateComplete: false,
            alert: {
                waterPoint: false,
                extractionRate: false,
                area: false,
                areaEmpty: false,
                countStart: false,
                countStartEnd: false,
                waterLevel: false,
                documentationAllowed: false,
                comment: false
            },
            minCommentLength: 5,
            transferIrrigationStartDate: '01.01',
            transferIrrigationEndDate:  '31.12'
        }
    },
    computed: {
        isComplete: function () {
            return (this.countEnd === null);         
        },
        hasImage: function () {
            return (Array.isArray(this.images) && this.images.length > 0);
        },
        isWaterPointSelected: function () {
            return !(this.waterPointId == null);          
        },
        isProfileWaterPoint: function () {
            return !(this.profile.waterPointId == null);          
        },
        showTransferIrrigationLevel: function () {
            /*
			const startDate = this.makeDate(this.transferIrrigationStartDate);
            const endDate = this.makeDate(this.transferIrrigationEndDate);
            
            const diffStart = -startDate.diff(this.startDate, 'day');
            const diffEnd = -endDate.diff(this.startDate, 'day');
            
            if (this.level !== null && diffStart >= 0 && diffEnd <= 0) {
                return true;
            }
			
			return false;
			*/
            
            // this.isMode('new_completely', 'complete', 'alter') 
            
            
            // this.isMode('new_completely', 'complete', 'alter')
            
            if (this.isMode(['new'])) {
                return this.isCreateComplete;
            }

            if (this.isMode(['view']) &&  this.isTransferIrrigationLevel == true) {
                return true;
            }
            
            if (this.isMode(['new_completely', 'complete', 'alter'])) {
                return true;
            }
            
            return false;
			
        },
        disabledTransferIrrigationLevel: function () {
            return (this.isMode('view') || this.irrigation.transferIrrigationLevel === true);
        },
        level: function () { 
            if (this.countStart !== null && this.countEnd !== null  && this.area !== null) {
                if (this.countStart < this.countEnd) {
                    // Level in mm
                    return (1000 * (this.countEnd-this.countStart)) / this.area;
                }
            }
            return null;
        },
        labelLevel: function () { 
            if ( this.level !== null ) {
                return '{} mm (auf {} ha)'.format(
                    this.level.toFixed(1),
                    (this.area / 10000).toFixed(1)
                ).replaceAll('.', ',');    
            }
            return null;
       }
    },
    methods: {
        openModal: function () {
            this.set(this.irrigation);
            this.$nextTick(function() { 
                this.$refs.modal.openModal();        
            });
        },
        closeModal: function () {
            this.$refs.modal.closeModal();                   
        },
        changeMode: function (mode) {
            this.$emit('update:mode', mode);        
        },
        submit: function () {
            if (!this.validateForm()) {
                return
            }
            
            let id = null;
            if (this.isMode('complete') && this.irrigation) {
                id = parseInt(this.irrigation.id);
            }
            
            let refId = null;
            if (this.isMode('alter') && this.irrigation) {
                if (this.irrigation.refId === null) {
                    refId = parseInt(this.irrigation.id);
                } else {
                    refId = parseInt(this.irrigation.refId);
                }
            }
            
            let irrigation = {
                profileId: parseInt(this.state.profile.id),
                waterpointId: parseInt(this.waterPointId),
                id: id,
                refId: refId,
                datetime: '{}T{}:{}'.format(this.startDate, this.startTime, dayjs().format('ss')),
                extractionRate: this.extractionRate,
                area: this.area && !this.profile.area ? Math.round(this.area*10000) : null,
                countStart: this.countStart,
                countEnd: this.isMode('new') ? null : this.countEnd,
                stillWaterLevel: this.isMode('new') ? null : this.stillWaterLevel,
                normalWaterLevel: this.isMode('new') ? null : this.normalWaterLevel,
                comment: this.isMode('new') ? null : this.comment,
                transferIrrigationLevel: this.isMode('new') ? null : this.isTransferIrrigationLevel,
                images: this.files
            }
            
            this.$emit('submit', irrigation);
            this.closeModal();            
        },
        validateForm: function () {
            this.alert.waterPoint = false;
            if ( !this.waterPointId ) {
                this.$nextTick(function() { 
                    this.alert.waterPoint = true;
                });
                return false;
            }
           
            /*
            this.alert.extractionRate = false;
            if ( this.extractionRate == 0 ) {
                this.$nextTick(function() { 
                    this.alert.extractionRate = true;
                });
                return false;
            }
            */
            
            this.alert.countStartEnd = false;
            if ( this.isMode(['new_completely','complete','alter']) && ( !(this.countStart > 0) || !(this.countEnd > 0) || !(this.countStart < this.countEnd)) ||
                 this.isMode(['new', 'new_completely','complete', 'alter']) && !(this.countStart > 0)
            ) {
                this.$nextTick(function() { 
                    this.alert.countStartEnd = true;
                });
                return false;
            }
            
            this.alert.countStart = false; 
            if ( this.isMode(['new', 'new_completely']) && this.countStart && this.getMinCountStart() && (this.countStart < this.getMinCountStart()) ) {
                this.$nextTick(function() { 
                    this.alert.countStart = true;
                });
                return false;
            }
            
            this.alert.waterLevel = false;
            if ( (this.stillWaterLevel && !this.normalWaterLevel) || (!this.stillWaterLevel && this.normalWaterLevel)) {
                this.$nextTick(function() { 
                    this.alert.waterLevel = true;
                });
                return false;
            }
            
            this.alert.comment = false;
            if ( this.isMode('alter') && (this.comment? this.comment.length < this.minCommentLength: true)) {
                this.$nextTick(function() { 
                    this.alert.comment = true;
                });
                return false;
            }
            
            this.alert.areaEmpty = false;
            if (!this.profile.area && !this.area) {
                this.$nextTick(function() { 
                    this.alert.areaEmpty = true;
                });
                return false;
            }
           
            if (!this.profile.area && this.alert.area === false) {
                this.$nextTick(function() { 
                    this.alert.area = true;
                 });
                return false;
            }
            

            return true;
        },
        isMode: function (modes) {
            if ( !Array.isArray(modes) ) {
                modes = Array.prototype.slice.call(arguments, 0);
            }
            return modes.includes(this.mode);
        },
        getDefaultDateTime: function () {
            return dayjs.max(
                this.makeDate(dayjs().format('DD.MM')),
                this.getMinDateTime()
            )
        },
        getMinDateTime: function () {
            let listMaxDateItem = this.getListMaxDateItem();
            
            if (listMaxDateItem) {
                return dayjs(listMaxDateItem.datetime);
            }
            return this.makeDate('01.01');
        },
        getMaxDateTime: function () {
            return dayjs.min(
                dayjs(),
                this.makeDate('31.12')
            )
        },
        getMinCountStart: function () {
            let listMaxDateItem = this.getListMaxDateItem();
            
            if (listMaxDateItem) {
                return listMaxDateItem.countStart;
            }
            return null;
        },
        dateToISOString: function (date) {
            return date.toISOString().substring(0, 10);
        },
        makeDate: function (ds) {
            return dayjs('{}-{}-{}'.format(
                this.state.profile.year,
                parseInt(ds.split('.')[1]),
                parseInt(ds.split('.')[0])
            ));
        },
        getListMaxDateItem: function () {
            if (this.irrigationList.length == 0 ) {
                return null;
            }
                        
            return this.irrigationList.reduce( function (a, b) {
                return dayjs(a.datetime) > dayjs(b.datetime)  ? a : b;
            })
            
        },
        countStartChanged: function () {
            this.$nextTick(function () {
                if (this.countStart !== null && this.isMode('new_completely', 'complete', 'alter')) {
                    if (this.countEnd !== null && this.countStart >= this.countEnd) {
                        this.countEnd = this.countStart + 0.001;
                    } 
                }
            });
        },
        countEndChanged: function () { 
            this.$nextTick(function () {
                if (this.countEnd !== null && this.isMode('new_completely', 'complete', 'alter')) {
                    if (this.countStart !== null && this.countStart >= this.countEnd) {
                        this.countEnd = this.countStart + 0.001;
                    }
                }
            });
        },
        set: function (irrigation) {
        
            if ( !(irrigation.waterpointId === undefined)) {
                this.waterPointId = parseInt(irrigation.waterpointId);
            } else {                
                this.waterPointId = this.profile.waterPointId;
            }
        
            if ( !(irrigation.extractionRate === undefined)) {
                this.extractionRate = irrigation.extractionRate;
            }  else {
                this.extractionRate = null;
            }
            
            if (irrigation.datetime) {
                this.startDate = dayjs(irrigation.datetime).format('YYYY-MM-DD');
                this.startTime = dayjs(irrigation.datetime).format('HH:mm'); 
            } else {
                this.startDate = this.getDefaultDateTime().format('YYYY-MM-DD');
                this.startTime = dayjs().format('HH:mm');             
            }
            
            if ( !(irrigation.countStart === undefined)) {
                this.countStart = irrigation.countStart;
            } else {
                this.countStart = null;
            }
            
            if ( !(irrigation.countEnd === undefined)) {
                this.countEnd = irrigation.countEnd;
            } else {
                this.countEnd = null;
            }
            
            if ( !(irrigation.stillWaterLevel === undefined)) {
                this.stillWaterLevel = irrigation.stillWaterLevel;
            } else {
                this.stillWaterLevel = null;
            }
            
            if ( !(irrigation.normalWaterLevel === undefined)) {
                this.normalWaterLevel = irrigation.normalWaterLevel;
            } else {
                this.normalWaterLevel = null;
            }
            
            if ( !(irrigation.comment === undefined)) {
                this.comment = irrigation.comment;
            } else {
                this.comment = null;
            }
            
            if ( !(irrigation.images === undefined)) {
                this.images = irrigation.images;
            } else {
                this.images = []
            }
            
            if ( !(irrigation.transferIrrigationLevel === undefined)) {
                this.isTransferIrrigationLevel = irrigation.transferIrrigationLevel;
            } else {
                this.isTransferIrrigationLevel = false;
            }
            
            if (this.isMode(['new_completely', 'complete'])) {
                this.isTransferIrrigationLevel = true;
            }
            
            
            this.area = this.profile.area;
        }
    },
    watch: {
        mode: function (new_value, old_value) {
            if ( old_value == 'new_completely' &&  new_value == 'new') {
                this.countEnd = null;
            }
        }, 
        isCreateComplete: function (new_value, old_value) {
            if ( old_value === false && new_value === true) {
                this.changeMode('new_completely');
            } else if ( old_value === true && new_value === false) {
                this.changeMode('new');
            }
        },
        isWellStillWaterLevelDocumented: function (new_value, old_value) {
            alert('changed');
        
            if ( old_value === false && new_value === true) {
                console.log(1);
            } 
        }
    },
    created: function () {
        
    },
    mounted: function () {
        
    }
}

</script>